import { render, staticRenderFns } from "./payment-history-card.vue?vue&type=template&id=33675108"
import script from "./payment-history-card.vue?vue&type=script&lang=js"
export * from "./payment-history-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports